import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturarEnlace } from '../lib/enlace';

/**
 * Recoge un enlace de referido de la URL en **cualquier** ruta.
 *
 * Tres formas, las tres válidas:
 *   · `?ref=CODIGO` — la nueva, para pegar a cualquier dirección;
 *   · `?code=CODIGO` — la de los enlaces de closer que ya se repartieron;
 *   · `?utm_source=6` — la de los QR de canal ya impresos en el outlet.
 *
 * `/r/CODIGO` tiene su propia pantalla (`EnlaceEntrada`), que además decide a
 * dónde mandar a la persona.
 *
 * Sustituye a `useCapturaCodigoCloser` y al rastreo de `utm_source` que vivía
 * dentro de la landing: eran dos caminos para lo mismo, y el segundo solo
 * funcionaba si la persona aterrizaba justo en la portada.
 */
export function useCapturaEnlace() {
  const location = useLocation();

  useEffect(() => {
    const q = new URLSearchParams(location.search);
    const codigo = q.get('ref') || q.get('code') || q.get('utm_source');
    if (codigo) capturarEnlace(codigo);
  }, [location.search]);
}

export default useCapturaEnlace;
